
(function loadingServiceDefinition() {

    'use strict';

    angular.module('Loading')
        .service('loading', [
            function loadingService() {

                var recursion = 0;
                var loaders = $();

                this.registerLoader = function registerLoader(element) {
                    loaders = loaders.add(element);
                    if (recursion) {
                        loaders.show();
                    }
                };
                this.unRegisterLoader = function unRegisterLoader(element) {
                    loaders = loaders.not(element);
                };
                this.show = function show() {
                    recursion++;
                    if (recursion === 1) {
                        loaders.show();
                    }
                };

                this.hide = function hide() {
                    recursion--;
                    if (recursion === 0) {
                        loaders.hide();
                    }
                };

            }
        ]);

})();